import { createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
var theme = createTheme({
    palette: {
        primary: {
            main: "rgba(37, 89, 149, 1)",
        },
        secondary: {
            main: orange[600],
        },
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: 'none',
                },
            },
        },
    },
});
export { theme };
